
import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { FeatureToggle } from '@clooper/core';

@Directive({
  selector: '[featureToggle]'
})
export class FeatureDirective implements OnInit {
  @Input() featureToggle: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private features: FeatureToggle
  ) { }

  ngOnInit() {
    if (this.isEnabled()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  isEnabled() {
    if (this.features['*']) {
      return true;
    }
    return this.features[this.featureToggle];
  }
}
